import { render, staticRenderFns } from "./first-level-nav.vue?vue&type=template&id=3c08acc9&scoped=true"
import script from "./first-level-nav.vue?vue&type=script&lang=js"
export * from "./first-level-nav.vue?vue&type=script&lang=js"
import style0 from "./first-level-nav.vue?vue&type=style&index=0&id=3c08acc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c08acc9",
  null
  
)

export default component.exports